/** @jsx jsx */

import { ColorValue, Icon, IconName } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

const Styles = {
  root: ({ backgroundColor, size }) => css`
    align-items: center;
    border-radius: 100px;
    background-color: ${backgroundColor};
    display: flex;
    height: ${size}px;
    justify-content: center;
    width: ${size}px;
  `,
};

type Props = {
  backgroundColor: ColorValue;
  name: IconName;
  size: number;
};

const GuideIcon = ({ backgroundColor, name, size }: Props) => {
  if (size === 0) {
    return null;
  }

  const isZapierLogo = name === 'zapierLogo';

  return (
    <div css={Styles.root({ backgroundColor, size })}>
      {isZapierLogo ? (
        <Icon name="zapierLogo" size={size / 2} />
      ) : (
        <Icon color="GrayWarm7" name={name} size={size / 2} />
      )}
    </div>
  );
};

export default GuideIcon;
